import type { ReviewApprovalItem, ReviewTrustAlert } from "../../../shared/types";

export function claimRiskAlerts(alerts: ReviewTrustAlert[] | null | undefined): ReviewTrustAlert[] {
  if (!alerts || alerts.length === 0) return [];
  return alerts.filter((alert) => alert.kind === "synthesis");
}

export function hasClaimRiskBlockedTrust(brief: Pick<ReviewApprovalItem, "review_trust_state" | "provenance_alerts">): boolean {
  return brief.review_trust_state === "claim_risk" || claimRiskAlerts(brief.provenance_alerts).length > 0;
}

export function claimRiskMessage(brief: Pick<ReviewApprovalItem, "provenance_alerts">): string {
  return claimRiskAlerts(brief.provenance_alerts)[0]?.detail
    ?? "This draft includes unsupported claims and should be rewritten before publishing.";
}

export function reviewTrustBadgeCopy(
  brief: Pick<ReviewApprovalItem, "review_trust_state" | "content_origin">,
): { label: string; variant: "default" | "success" | "warning" | "info"; body: string } {
  switch (brief.review_trust_state) {
    case "source_backed":
      return { label: "Source-backed", variant: "success", body: "Linked evidence is intact and approval can focus on the draft itself." };
    case "manual_reviewed":
      return { label: "Manual packet", variant: "info", body: "This draft came from a reviewed operator packet, so there is no source run to repair first." };
    case "brand_context_only":
      return { label: "Brand context only", variant: "default", body: "This draft uses saved brand guidance rather than linked external evidence." };
    case "broken_lineage":
      return { label: "Broken lineage", variant: "warning", body: "Approval is blocked until the missing source trail is repaired or rerun." };
    case "claim_risk":
      return { label: "Claim risk", variant: "warning", body: "The draft makes unsupported claims and needs a safer rewrite before approval." };
    case "legacy_unknown":
    default:
      return { label: "Legacy review", variant: "default", body: "This draft predates the current trust model, so treat provenance cautiously." };
  }
}
